






































import "./attachment-editor.less";
import Vue from "vue";
import ResizableTextarea from "../common/ResizableTextarea.js";

export default Vue.extend({
  name: "attachment-editor",
  components: { ResizableTextarea },
  props: {
    attachment: Object,
    disableEdit: Boolean,
  },
  data() {
    return {
      mode: "normal",
      currentAttachment: {
        link: null,
        title: null,
        type: null,
      },
      linkTypeOptions: [
        { value: 1, label: "Video Link", disabled: false },
        { value: 2, label: "Document Link", disabled: false },
        { value: 3, label: "Web Link", disabled: false },
      ],
      rules: {
        link: [
          {
            required: true,
            message: "Please fill in the attachment link.",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "Please fill in the attachment name.",
            trigger: "blur",
          },
          {
            type: "string",
            max: 60,
            message: "Please limit the attachment name to max 60 characters.",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            type: "number",
            message: "Please select attachment link type.",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.attachment.link === null) {
      this.handleEdit();
    }
  },
  methods: {
    getTypeString(type) {
      if (type === 1) {
        return " (video link)";
      } else if (type === 2) {
        return " (document link)";
      } else if (type === 3) {
        return " (web link)";
      } else {
        return "";
      }
    },
    handleEdit() {
      this.currentAttachment.link = this.attachment.link;
      this.currentAttachment.title = this.attachment.title;
      this.currentAttachment.type = this.attachment.type;

      this.mode = "edit";
      this.$emit("editting");
    },
    handleRemove() {
      this.$emit("remove");
    },
    handleSave() {
      event.preventDefault();
      let form = this.$refs.EditForm;

      (form as any).validate((valid: boolean) => {
        if (valid) {
          this.attachment.link = this.currentAttachment.link;
          this.attachment.title = this.currentAttachment.title;
          this.attachment.type = this.currentAttachment.type;
          this.attachment.status = "saved";
          this.mode = "normal";
          this.$emit("edittingEnd");
        }
      });
    },
    handleCancel() {
      this.mode = "normal";
      if (this.attachment.link === null) {
        this.$emit("cancelAddNew");
      }

      this.$emit("edittingEnd");
    },
    cancel() {},
  },
});
